import { Link } from "react-router-dom";
import type { CaseItem } from "@/mocks/cases";
import { formatHeat } from "@/utils/format";

interface CaseCardProps {
  item: CaseItem;
  rank?: number;
}

export default function CaseCard({ item, rank }: CaseCardProps) {
  return (
    <article className="group flex flex-col h-full rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300">
      <Link to={`/archive/${item.id}`} className="relative block w-full h-44 overflow-hidden cursor-pointer">
        <img
          src={item.cover}
          alt={`${item.title} 档案封面`}
          title={`${item.title} - 独家黑料证据链`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-primary-950/85 text-background-50 text-xs">
          <i className="ri-file-text-line" />
          {item.categoryName}
        </span>
        {typeof rank === "number" && (
          <span className="absolute top-3 right-3 flex w-8 h-8 items-center justify-center rounded-md bg-accent-500 text-primary-950 font-heading font-bold">
            {rank}
          </span>
        )}
      </Link>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
          <Link to={`/archive/${item.id}`} className="hover:text-primary-700 transition-colors cursor-pointer">
            {item.title}
          </Link>
        </h3>
        <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 line-clamp-3">{item.summary}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.evidences.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-fire-line text-primary-500" />
            {formatHeat(item.heat)}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line" />
            {item.publishedAt}
          </span>
        </div>
      </div>
    </article>
  );
}